import { usePageContext } from '../../../../context.js';
import { useTaskContext } from '../../context.js';
import { FacitContainer } from './container.facit.js';
import { InputContainer } from './container.input.js';
import { PrintContainer } from './container.print.js';
import { jsx } from 'react/jsx-runtime';

function SequenceSentenceTask(props) {
  const context = useTaskContext();
  const pageContext = usePageContext();
  if (pageContext === "print") {
    return /*#__PURE__*/jsx(PrintContainer, {
      ...props
    });
  }
  if (context === "input") {
    return /*#__PURE__*/jsx(InputContainer, {
      ...props
    });
  } else {
    return /*#__PURE__*/jsx(FacitContainer, {
      ...props
    });
  }
}

export { SequenceSentenceTask };
//# sourceMappingURL=_task.sentence.js.map
